export default __webpack_public_path__ + "static/media/B18 00_00_00-00_41_00.10aa9c9f.mp4";